import {
  API_RESET,
  GET_DATA_INDEX,
  SET_DATA_INDEX,
  API_ERROR,
  API_SUCCESS,
  GET_DATA_SHOW,
  SET_DATA_SHOW,
  DATA_CREATE,
  DATA_EDIT,
  DATA_DELETE,
} from "./actionTypes";

export const apiReset = () => {
  return {
    type: API_RESET,
    payload: {},
  };
};

export const apiError = (message) => {
  return {
    type: API_ERROR,
    payload: message,
  };
};

export const apiSuccess = (message) => {
  return {
    type: API_SUCCESS,
    payload: message,
  };
};

export const getDataIndex = (page, qnt, filter, isForm) => {
  return {
    type: GET_DATA_INDEX,
    payload: { page, qnt, filter, isForm },
  };
};
export const setDataIndex = (data) => {
  return {
    type: SET_DATA_INDEX,
    payload: data,
  };
};

export const getDataShow = (idData, isForm) => {
  return {
    type: GET_DATA_SHOW,
    payload: { idData, isForm },
  };
};
export const setDataShow = (data) => {
  return {
    type: SET_DATA_SHOW,
    payload: data,
  };
};

export const dataCreate = (newDataValues) => {
  return {
    type: DATA_CREATE,
    payload: { newDataValues },
  };
};
export const dataEdit = (idData, newDataValues) => {
  return {
    type: DATA_EDIT,
    payload: { idData, newDataValues },
  };
};
export const dataDelete = (idData) => {
  return {
    type: DATA_DELETE,
    payload: { idData },
  };
};
